<template>
	<div>
		<div class="top-bar">
			<div class="top-color">
				<div style="float: left;margin: -6px 0 0 90px;">
					<ul class="list-bar-ui">
						<router-link to="/"><li>首页</li></router-link>
						<router-link to="/meorder"><li>我的订单</li></router-link>
						<router-link to="/change"><li>我的账户</li></router-link>
					</ul>
				</div>
				<img src="https://testing-oss.oss-cn-shanghai.aliyuncs.com/2019/06/19/46c041b.jpg?1560929792#w" alt="" />
					<div style="position: absolute;top: 5px;right: 190px;">
						<span v-if="show" @click="clickbar" class="car-bar-box"></span>&nbsp;&nbsp;
						<span v-if="show" @click="clickbar" class="car-bar-box-one">购物车  ￥{{total}}</span>
					</div>
					<div style="position: absolute;top: 5px;right: 5px;">
						<span @click="toLogin" class="car-bar-box-three">注销</span>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
import { removeLocalStore } from '../util/util'
import { carMoney } from '../api/service'

export default {
	data() {
		return {
			money: 0
		}
	},
	props: {
	  show: {
            type: Boolean,
            default: false
	  },
	  activity: {
            type: String,
            default: ''
	  },
	  activityName: {
            type: String,
            default: ''
	  },
	  activityLimit: {
            type: String,
            default: ''
	  },
	  surplusLimit: {
            type: String,
            default: ''
	  },
	  totalMoney: {
		  type: Number,
		  default: 0
	  }
	},
	computed: {
		// 计算属性的 getter
		total: function () {
		// `this` 指向 vm 实例
			return this.totalMoney === 0 ? this.money: this.totalMoney
		}
  	},
	methods: {
		clickbar() {
			const para = {
				activityId: this.activity,
				activityName: this.activityName,
				activityLimit: this.activityLimit,
				surplusLimit: this.surplusLimit
			}
			this.$router.push({ path: 'vehicle', query: para })
		},
		fetchData () {
			const params = {
				activityId: this.activity,
				staffId: this.$store.getters.id
			}
			carMoney(params).then(response => {
				if (response.data.success === true) {
					this.money = response.data.data
				} 
			}).catch(() => {
			})
		},
		toLogin () {
			removeLocalStore('Access-Id')
			removeLocalStore('User-Name')
			removeLocalStore('User-Phone')
			removeLocalStore('Delivery-Address')
			removeLocalStore('Image-Url')
			this.$router.push({ path: 'signin' })
		}
	},
	created() {
		if (this.totalMoney===0) {
			this.fetchData()
		} 
	}
};
</script>

<style scoped>
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 450px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	display: inline-block;
}
.car-bar-box-one {
	color: #FFA500;
	font-size: 13px;
	cursor: pointer;
	height: 30px;
	display: inline-block;
	position: relative;
	top: -9px;
}
.car-bar-box-two {
	color: #FFA500;
	font-size: 13px;
	cursor: pointer;
	height: 30px;
	display: inline-block;
	margin-top: 10px;
	position: relative;
	top: -9px;
}
.car-bar-box-three {
	color: #FFA500;
	font-size: 16px;
	cursor: pointer;
	height: 30px;
	display: inline-block;
	margin-top: 4px;
}
</style>
